import { cn } from '@exam-room/utils';
import { Outlet } from 'react-router-dom';

export default function Page({
  children = null,
  containerClassName = '',
}: {
  children?: React.ReactNode;
  containerClassName?: string;
}) {
  return (
    <main id='page' className={cn('flex h-dvh w-full flex-col', containerClassName)}>
      {children ?? <Outlet />}
    </main>
  );
}
